import { FormInstance } from "domain/entities/form-instance";
import { FormTemplate } from "domain/entities/form-template";

import { useFormsEditStore } from "presentation/stores/use-forms-edit.store";

import { Button } from "primereact/button";

import {
  FileUpload,
  FileUploadFile,
} from "primereact/fileupload";

import { FloatLabel } from "primereact/floatlabel";

import { InputSwitch } from "primereact/inputswitch";

import { InputText } from "primereact/inputtext";

import { InputTextarea } from "primereact/inputtextarea";

import { Toast } from "primereact/toast";

import {
  useCreateFormsInstanceMutation,
  useUpdateFormsInstanceMutation,
} from "presentation/hooks/use-query-formsinstance";

import {
  useEffect,
  useRef,
  useState,
} from "react";

import { httpClient } from "infra/axios/axios-api";
import { InputNumber } from "primereact/inputnumber";
import { Tag } from "primereact/tag";

const CreateInstance = ({
  templateId,
  close,
  mode = "create",
  initialData,
}: {
  templateId: string | FormTemplate;
  close: () => void;
  mode?: "create" | "edit";
  initialData?: FormInstance | null;
}) => {
  const createInstance =
    useCreateFormsInstanceMutation();

  const updateInstance =
    useUpdateFormsInstanceMutation();

  const state = useFormsEditStore();

  const [instanceTitle, setInstanceTitle] =
    useState<string>("");

  const [questionsPerPage, setQuestionsPerPage] =
    useState<number>(1);

  const [
    instanceDescription,
    setInstanceDescription,
  ] = useState<string>("");

  const [isAnonymous, setIsAnonymous] =
    useState<boolean>(false);
 
  const [logo, setLogo] =
    useState<FileUploadFile | null>(null);

  const toast = useRef<Toast>(null);

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setInstanceTitle(initialData.title || "");
      setInstanceDescription(initialData.description || "");
      setIsAnonymous(initialData.isAnonymous || false);
      setQuestionsPerPage(initialData.questionPerPage || 1);
    }
  }, [mode, initialData]);

  const showToastError = (detail: string) => {
    toast.current?.show({
      severity: "error",
      summary: "Erro",
      detail,
      life: 1500,
    });
  };

  const showToastSuccess = (detail: string) => {
    toast.current?.show({
      severity: "success",
      summary: "Sucesso",
      detail,
      life: 1500,
    });
  };

  const validateFields = (): boolean => {
    if (instanceTitle.trim() === "") {
      showToastError("Por favor dê um título à instância");
      return false;
    }
    return true;
  };

  const uploadLogo = async (): Promise<string> => {
    if (!logo) return "";

    try {
      const ext = logo.name.split(".").pop();
      const uniqueName = `${crypto.randomUUID()}.${ext}`;

      const formData = new FormData();
      formData.append("file", logo, uniqueName);

      const folder = `nimberForms/${typeof templateId === "string" ? templateId : templateId.id}`;

      const response = await httpClient.post(
        `/assets/${folder}`,
        formData
      );

      return response.data.filePath || "";
    } catch (err) {
      console.error("Erro no upload:", err);
      showToastError("Erro ao fazer upload do logo");
      return "";
    }
  };

  const deleteOldLogo = async (logoPath: string): Promise<boolean> => {
    try{
      const response = await httpClient.delete(
        `/assets/${logoPath}`,
      );
      if(!response.data.result){
        showToastSuccess("Logo antigo deletado com sucesso");
        return true;
      }
        showToastError("Erro ao apagar o logo antigo");
        return false;
    }catch(err) {
      console.error("Erro na deleção do logo antigo", err);
      showToastError("Erro ao fazer ao fazer a deleção do logo antigo");
      return false;
    }
  }
  const generateInstance = async () => {
    if (!validateFields()) return null;

    if(initialData?.logo && logo && initialData.logo.trim() !== "" && mode === "edit") {
      const deleted = await deleteOldLogo(initialData.logo);
      if (!deleted) {
        return null;
      }
    }

    const logoPath = await uploadLogo();
    let actualPathForLogo: string;
    actualPathForLogo = logoPath;
    if(!logoPath)
      actualPathForLogo = initialData?.logo ?? "";

    const instance: FormInstance = {
      title: instanceTitle,
      description: instanceDescription,
      isAnonymous,
      logo: actualPathForLogo,
      slug: "",
      active: initialData?.active ?? true,
      templateId: templateId,
      questionPerPage: questionsPerPage
    };
    try {
      let response;

      if (mode === "edit") {
        console.log(instance);
        response = await updateInstance.mutateAsync({
          id: initialData?.id || "",
          instance,
        });
        console.log(response);
      } else {
        response = await createInstance.mutateAsync(instance);
      }

      if (response.data) {
        state.setFormsEdit({
          instance: response.data,
        });

        return response.data;
      }

      return null;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const addAnonymousWarning = () => {
    if (!isAnonymous) return <div />;

    return (
      <Tag 
      severity="warning"
      className="mb-0 w-auto" 
      style={{ alignSelf: 'flex-start' }}
      icon="pi pi-exclamation-triangle"
      value="As respostas serão anónimas"
      />
    );
  };

  const itemTemplate = (file: any, props: any) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
            </div>
        );
    };

  const emptyTemplate = () => {
      return (
          <div className="flex align-items-center flex-row justify-content-center">
              <i className="pi pi-plus mr-2 p-2" style={{ fontSize: '1em', borderRadius: '50%', border: "1px solid" }}></i>
              <span style={{ fontSize: '1em', color: 'var(--text-color-secondary)' }} className="my-2">
                  Arraste o Logo da Instituição
              </span>
          </div>
      );
  };

   return (
    <div style={{width: "100%", display: "flex", flexDirection: "column", marginTop: "1.5rem"}}>
        <div style={{width: "100%", display: "flex", gap: "2rem", flexDirection: "column"}}>
            
            <FloatLabel>
                <InputText
                style={{
                    width: "100%",
                    fontSize: "1.2rem"
                }}
                value={instanceTitle}
                onChange={(e) => setInstanceTitle(e.target.value)}
                id="instanceTitle"
                disabled={mode === "edit"}
                />
                <label htmlFor="instanceTitle">Título</label>
            </FloatLabel>
            <FloatLabel>
                <InputTextarea
                rows={3} 
                cols={30}
                style={{
                    width: "100%",
                    fontSize: "1rem"
                }}
                value={instanceDescription}
                onChange={(e) => setInstanceDescription(e.target.value)}
                id="instanceDescription"
                />
                <label htmlFor="instanceDescription">Descrição</label>
            </FloatLabel>
        </div>
        <div style={{
            width: "100%", 
            display: "flex", 
            flexDirection: "row",
            marginTop: "1rem",
            gap: "1.5rem"
            }}>
            <div style={{
                width: "50%", 
                display: "flex", 
                justifyContent: "center",
                border: "1px solid", 
                borderColor: 'var(--surface-d)',
                borderRadius: "8px", 
                gap: "0.2rem",
                flexDirection: "column",
                minHeight: "4rem",
                height: "fit-content",
            }}>
                <div style={{
                    display: "flex", 
                    width: "90%",
                    justifyContent: "space-between",
                    alignItems: "center", 
                    margin: "0 auto",
                    marginTop: "1rem",
                    marginBottom: "1.5rem",
                }}>
                  <div className="flex flex-column">
                    {addAnonymousWarning()}
                    <label htmlFor="switch">Respostas anónimas</label>
                  </div>
                    <InputSwitch 
                        checked={isAnonymous} 
                        onChange={(e) => {setIsAnonymous(e.value);}}
                    />
                </div>
            </div>
            <div style={{ 
                display: "flex", 
                flexDirection: "column", 
                gap: "0.5rem",
                width: "50%",
                }}>
                <label htmlFor="questionsPerPage">Perguntas por página</label>
                <InputNumber 
                style={
                  {
                    borderRadius: "8px",
                  }
                }
                id="questionsPerPage"
                value={questionsPerPage}
                decrementButtonClassName="p-button-secondary"
                incrementButtonClassName="p-button-secondary"
                onValueChange={(e) => {
                  setQuestionsPerPage(e.value as number)
                }}
                min={1}
                showButtons
                />
            </div>

        </div>
        <div style={{ 
              display: "flex", 
              flexDirection: "column", 
              marginTop: "1rem",
              }}>
              <FileUpload 
              auto={false} 
              emptyTemplate={emptyTemplate}
              itemTemplate={itemTemplate}
              uploadOptions={{ className: 'hidden' }}
              chooseOptions={{style: {borderRadius: "8px"}}}
              cancelOptions={{label: "Remover", style: {borderRadius: "8px"}}}
              accept="image/*"
              customUpload 
              maxFileSize={1000000} 
              onValidationFail={(file) => {
                  showToastError(`O arquivo ${file.name} excede o tamanho máximo permitido (10MB)`)
              }}
              onSelect={(e) => setLogo(e.files[0])} 
              chooseLabel="Escolher Logo"
              id="logoUpload"
              />
        </div>
        <div style={{display: "flex", justifyContent: "end"}}>
            <Button 
            style={{
              marginTop: "1.5rem", 
              borderRadius: "8px",
            }}
            label={
              mode === "edit"
                ? "Editar Instância"
                : "Criar Instância"
            }
            onClick={async () => {
              const result = await generateInstance();

              if (result) {
                showToastSuccess(
                  mode === "edit"
                    ? "Instância editada com sucesso"
                    : "Instância criada com sucesso"
                );
                close();
              } else {
                showToastError(
                  mode === "edit"
                    ? "Erro ao editar instância"
                    : "Erro ao criar instância"
                );
              }
            }}
            />

      <Toast ref={toast} />
      </div>
    </div>
  );
};

export default CreateInstance;